/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".view-controls[_ngcontent-%COMP%], app-comments[_ngcontent-%COMP%]{margin-top:1rem}.view-controls[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{display:inline-block;margin-right:1rem}"];
export { styles as styles };

